import PropTypes from "prop-types";
import React from "react";

import { getCertificationMeta } from "../../constants/certification";

/**
 * Certification level badge.
 *
 * The raw integer used to be rendered on its own — "Certifié (3)" told an
 * admin nothing about what level 3 meant. The label comes from the shared
 * enum so every screen names the levels the same way.
 *
 * `is_certified` is the source of truth for whether the badge shows at all;
 * some screens still keyed off `banca_certificate > 0`, which drifted from
 * the backend's own rule.
 */
const CertificationBadge = ({ professional, showLevel = true, className }) => {
  if (!professional) return null;

  const level = professional.banca_certificate ?? 0;
  const isCertified = professional.is_certified ?? level > 0;

  if (!isCertified) {
    return (
      <span className={`badge badge-soft-secondary fs-11 ${className || ""}`}>
        Non certifié
      </span>
    );
  }

  const meta = getCertificationMeta(level);

  return (
    <span
      className={`${meta.badgeClass} fs-11 ${className || ""}`}
      title={meta.description}
    >
      {showLevel ? meta.label : "Certifié"}
    </span>
  );
};

CertificationBadge.propTypes = {
  professional: PropTypes.object,
  showLevel: PropTypes.bool,
  className: PropTypes.string,
};

export default CertificationBadge;
